import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

import { NavService } from './../navigation/navigation.service';
import { CVFormService } from './../coverage-form.service';
import { FormPreliminary } from './../coverage-form.interface';

import {
  PaxFormControlService,
  BackendService,
  BobtailStore,
  SAVE_FORM,
  UPDATE_STORE
} from './../../shared/index';
import { FormCustomerInformationService } from './form-customer-information.service';

declare var fbq;

@Component({
  selector: 'pax-cf-form-customer-information',
  template: require('./form-customer-information.component.html'),
  providers: [
    PaxFormControlService,
    FormCustomerInformationService
  ]
})
export class FormCustomerInformationComponent implements OnInit, OnDestroy {
  formCustomerInformation: FormGroup;
  questions: any[];
  payload: Object = {};
  preliminary: FormPreliminary = {
    zip: '',
    truckValue: ''
  };
  storeData;
  routeData;
  formSubmitted = false;

  constructor(
    private _store: Store<any>,
    private _backend: BackendService,
    private FormControlService: PaxFormControlService,
    private dataService: FormCustomerInformationService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _cv: CVFormService,
    private _ns: NavService
  ) {}

  ngOnInit() {
    // resolve router data
    this.routeData = this._route.data.subscribe((data) => {

      const forms = data['forms'][1];

      // if ((this._cv.appEnv === 'live') && !forms['customer-information']) {
      //   console.log('fbq on customer information');
      //   fbq('track', 'CompleteRegistration');
      // }

      this._store.dispatch({ type: UPDATE_STORE, payload: { steps: forms, settings: data['forms'][0] } });
    });

    // get fields array from the service
    this.questions = this.dataService.getQuestions();
    // init the form
    this.formCustomerInformation = this.FormControlService.toFormGroup(this.questions);

    // get data from store and prefill the form
    this.storeData = this._store.select('cvform').subscribe((store: BobtailStore) => {
      let patchZip = {};
      let storeForm = store.steps['customer-information'] || {};

      // get zip code from preliminary step ...
      if (store.steps['preliminary']) {
        this.preliminary = store.steps['preliminary'];
        patchZip['zip'] = this.preliminary['zip'];
      }

      // merge the two objects, so that store override preliminary
      this.payload = Object.assign({}, storeForm, patchZip);

    }, error => console.log(error),
    () => console.log('complete'));

    this.formCustomerInformation.patchValue(this.payload || {});
  }

  ngOnDestroy() {
    this.storeData.unsubscribe();
    this.routeData.unsubscribe();
  }

  // update zip code on the fly
  onChange(e) {
    if (e.target.id !== 'zip') { return false; }

    this._backend.getSetting(e.target.value)
      .then(data => {
        this._store.dispatch({ type: UPDATE_STORE, payload: { settings: data } });
      });

    let p = this.formCustomerInformation.valid ? {
      preliminary: Object.assign({}, this.preliminary, { zip: e.target.value }),
      'customer-information': Object.assign({}, this.payload, { zip: e.target.value })
    } : {
      preliminary: Object.assign({}, this.preliminary, { zip: e.target.value })
    };
    this._store.dispatch({ type: SAVE_FORM, payload: p });
  }

  onSubmit() {
    this.formSubmitted = true;

    this._cv.sendToServerAndUpdateStore('preliminary', this.preliminary)
      .then(() => this._cv.sendToServerAndUpdateStore('customer-information', this.formCustomerInformation.value))
      .then(() => {
          this._ns.manualActiveStep('vehicles-information');
          this._router.navigate(['']);
      })
      .catch(err => console.log(err));
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/form-customer-information/form-customer-information.component.ts